module.exports = __webpack_public_path__ + "assets/images/22f7d6f1e6a0fc699ca8726fd72fca4e.png";